import React from 'react';
import { testId } from '@jwp/ott-common/src/utils/common';
import { formatTime } from '@jwp/ott-ui-react/src/utils/formatTime';
import { useTranslation } from 'react-i18next';

import styles from './CustomPlayer.module.scss';

export type AdPlaybackState = {
  position: number;
  duration: number;
  remaining: number;
  sequencePosition: number;
  sequenceLength: number;
  canSkip: boolean;
  isSkippable: boolean;
  skipInSeconds: number;
};

type Props = {
  ad: AdPlaybackState;
  onSkip: () => void;
};

const CustomPlayerAdChrome: React.FC<Props> = ({ ad, onSkip }) => {
  const { t } = useTranslation('video');
  const progress = ad.duration > 0 ? Math.min(100, (ad.position / ad.duration) * 100) : 0;
  const sequenceLabel = ad.sequenceLength > 1 ? ` (${ad.sequencePosition} of ${ad.sequenceLength})` : '';

  return (
    <div className={styles.adChrome} data-testid={testId('custom-player-ad-chrome')}>
      {/* {ad.canSkip ? (
          <button type="button" className={styles.adChromeSkip} onClick={onSkip}>
            {t('skip_ad', { defaultValue: 'Skip Ad' })}
          </button>
        ) : ad.isSkippable && ad.skipInSeconds > 0 ? (
          <span className={styles.adChromeSkipPending}>
            {t('skip_in', { defaultValue: 'Skip in {{time}}', time: formatTime(ad.skipInSeconds) })}
          </span>
        ) : null} */}
      <div className={styles.adChromeMeta}>
        <span className={styles.adChromeBadge}>{t('ad', { defaultValue: 'Ad' })}</span>
        <span className={styles.adChromeTime}>
          {formatTime(ad.remaining)}
          {sequenceLabel}
        </span>
        
      </div>
      <div className={styles.adChromeSeekTrack} aria-hidden>
        <div className={styles.adChromeSeekPlayed} style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};

export default CustomPlayerAdChrome;
